import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';

const BusinessInfo = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const formik = useFormik({
        initialValues: {
            id: '',
            name: '',
            email: '',
            phone: '',
            status: '',
            roleId: '',
            password: ''
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="email">Account Number</label>
                        <InputText id="email" name="email" placeholder="Account Number" value={formik?.values?.email} maxLength={30} onChange={formik.handleChange} disabled />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">Bank</label>
                        <InputText id="name" name="name" placeholder="Bank Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="email">Beneficiary</label>
                        <InputText id="email" name="email" placeholder="Beneficiary" value={formik?.values?.email} maxLength={30} onChange={formik.handleChange} disabled />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
            </div>
        </form>
    );
};

export default BusinessInfo;
